import type { ComplianceSettingsResponse, ComplianceRulesetSummary } from '../../../features/compliance/api';

/**
 * 商品の業界カテゴリに該当するコンプラルール候補を返す。
 * applicable_industries が NULL のルール (横断、例: 景表法) は常に含める。
 *
 * ManualProductDetailPage.tsx (表示ビュー renderDetailRows) と ProductInfoEditTable (編集ビュー)
 * の両方が使う共有ヘルパー。コンポーネントとは別ファイルに分離しているのは、
 * react-refresh/only-export-components (Fast Refresh はコンポーネントのみをエクスポートする
 * ファイルでないと効かない) を満たすため。計画書: docs/features/product-add-modal-flow-plan.md §4.1
 */
export function complianceCandidateRulesets(
  settings: ComplianceSettingsResponse | undefined,
  industryCategories: string[],
): ComplianceRulesetSummary[] {
  if (!settings || !settings.effective_compliance_enabled) return [];
  return settings.rulesets.filter((r) => {
    if (r.applicable_industries === null) return true;
    return r.applicable_industries.some((c) => industryCategories.includes(c));
  });
}
